<template>
  <div :class="bem({ condensed: view === 'code' })">
    <div :class="bem('main-image-wrapper')">
      <DatoCmsImage
        v-if="headlineImage"
        :data="headlineImage.responsiveImage"
        object-fit="cover"
        :object-position="`${headlineImage.focalPoint.x * 100}% ${
          headlineImage.focalPoint.y * 100
        }%`"
        :class="bem('main-image')"
        :priority="true"
      />
    </div>
    <div :class="bem('badge-image')">
      <DatoCmsImage
        v-if="badgeImage"
        :data="badgeImage.responsiveImage"
        object-fit="cover"
        :object-position="`${badgeImage.focalPoint.x * 100}% ${
          badgeImage.focalPoint.y * 100
        }%`"
        :priority="true"
      />
    </div>
  </div>
</template>

<script setup>
import { Image as DatoCmsImage } from 'vue-datocms'
const bem = useBEM('StravaHeadlineImage')

defineProps({
  headlineImage: {
    type: Object,
    default: () => ({})
  },
  badgeImage: {
    type: Object,
    default: () => ({})
  },
  view: { type: String, default: 'form' }
})
</script>

<style lang="postcss" scoped>
.StravaHeadlineImage {
  @apply relative;
}

.StravaHeadlineImage--condensed {
  .StravaHeadlineImage__main-image-wrapper {
    @screen md {
      width: 75%;
    }
  }
}

.StravaHeadlineImage__main-image-wrapper {
  @apply pb-[12.5%] w-full mx-auto duration-300 ease-in-out;

  transition-property: width;
}

.StravaHeadlineImage__main-image,
.StravaHeadlineImage__badge-image {
  @apply rounded-sm;
}

.StravaHeadlineImage__main-image {
  @apply w-full aspect-[800/900];
}

.StravaHeadlineImage__badge-image {
  @apply xsMax:w-3/12 w-2/12 absolute bottom-[12.5%] -translate-x-1/2 translate-y-1/2 left-1/2 z-10 overflow-hidden;
}
</style>